import React from "react";
import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, intro, align = "left", dark = false, className = "" }) => {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  const titleColor = dark ? "text-white" : "text-navy";
  const introColor = dark ? "text-white/70" : "text-secondary-ssa";
  return (
    <Reveal className={`flex flex-col ${alignCls} ${align === "center" ? "max-w-2xl" : "max-w-3xl"} ${className}`}>
      {eyebrow && (
        <div className={`flex items-center gap-3 mb-4 ${align === "center" ? "justify-center" : ""}`}>
          <span className="h-px w-8" style={{ background: "var(--ssa-gold)" }} />
          <span className="eyebrow text-gold">{eyebrow}</span>
        </div>
      )}
      <h2 className={`text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] ${titleColor}`}>{title}</h2>
      {intro && <p className={`mt-5 text-base sm:text-lg leading-relaxed ${introColor}`}>{intro}</p>}
    </Reveal>
  );
};
